import script from "./TitleAndDate.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleAndDate.vue?vue&type=script&setup=true&lang=js"

import "./TitleAndDate.vue?vue&type=style&index=0&id=54ba6bb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ba6bb4"]])

export default __exports__